export default "__VITE_ASSET__5C5jft7A__"